import { TamediaStyles } from '@ta-interaktiv/microfrontend-template-helpers'
import styled from 'styled-components'
import { GlobalVariables } from 'Globals/GlobalVariables'
import { MapboxMap } from 'components/MapboxMap'
import { useState, createContext, useEffect } from 'react'
import { strings_de } from './strings_de'
import { useElementSize, useWindowSize } from 'usehooks-ts'
import GlobalContext from 'Contexts/GlobalContext'
import { de, fr } from 'Globals/locale'

export const LanguageContext = createContext(strings_de)

const MainComponent = ({
  tenant,
  colorMode,
  properties,
  trackEvent,
}: MicroFrontendProps) => {
  const [selectedKmPop, setSelectedKmPop] = useState<number | undefined>(
    undefined
  )
  const [windowHeight, setWindowHeight] = useState(window.innerHeight)
  const { width } = useWindowSize()
  const [ref, containerSize] = useElementSize()

  const currentLocale = tenant.lang == 'fr' ? fr : de

  useEffect(() => {
    setWindowHeight(window.innerHeight)
  }, [width, setWindowHeight])

  return (
    <AppContainer $colorMode={colorMode}>
      <GlobalContext.Provider
        value={{
          tenant,
          colorMode,
          trackEvent,
          properties,
          locale: currentLocale,
        }}
      >
        <h3>{currentLocale.title}</h3>
        <div className='sub'>{currentLocale.sub}</div>
        <div ref={ref}>
          <MapboxMap
            tenant={tenant ? tenant : strings_de.fallbackTenant}
            windowHeight={windowHeight}
            isMobile={
              containerSize &&
              containerSize.width !== undefined &&
              containerSize.width < 712
            }
            colorMode={colorMode}
            setSelectedKmPop={setSelectedKmPop}
          />
        </div>
      </GlobalContext.Provider>
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`
  ${GlobalVariables}
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;

  h3 {
    margin-bottom: 0.4rem;
    font-size: 2rem;
    padding-left: 1rem;
  }
  .sub {
    margin-bottom: 2.2rem;
    font-size: 1.6rem;
    line-height: 2.2rem;
    padding-left: 1rem;
  }
`
export default MainComponent
